module.exports = __webpack_public_path__ + "static/media/pricingActive.dc8d8264.svg";